export default "__VITE_ASSET__DpByXtTS__"